import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { ButtonPrimary, Icon, ModalClose } from '../../../common/components';
import { TagManager } from '../../utils/analytics/TagManager';
import React, { useContext } from 'react';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

type ContactUsModalProps = {
  isDirectCustomer: boolean;
  isTpiCustomer: boolean;
  contactEmail: string;
  contactNumber: string;
  fixed?: boolean;
  show: boolean;
  onHide: any;
};

interface ContactInfoProps {
  icon: string;
  contact: string;
  href: string;
}

const defaultProps = {
  isDirectCustomer: true,
  isTpiCustomer: false,
  contactEmail: '',
  contactNumber: '',
  show: true,
};

const contentByUserType = {
  directCustomer: {
    titleTop: 'You have an overdue balance, please pay urgently to avoid further action',
    titleBottom: 'If you want to make a full payment without contacting us, you can do this on our online facility',
    headerTop: 'If you are struggling to make payment please contact us as we might be able to help.',
    headerBottom: 'This will open an external web page to allow you to make a secure payment.',
    footer:
      "If you have a query regarding your latest invoice(s), or want to discuss a query you've previously raised, please get in touch using the contact details on your invoice.",
  },
  tpi: {
    titleTop: 'There is an overdue balance on the account',
    titleBottom: '',
    headerTop:
      'If your customer is struggling to make payment please ask them to contact us as we might be able to help.',
    headerBottom: '',
    footer:
      'If you have a query regarding their latest invoice(s), or want to discuss a query previously raised, please get in touch using the contact details on the invoice.',
  },
};

export const ContactUsWrapper = styled.div`
  .paymentBtn {
    width: 300px;
    margin: auto;
    display: block;
  }
`;

const ContactInfo: React.FC<ContactInfoProps> = ({ icon, contact, href }) => (
  <div className='pl-4'>
    <Icon size={17} icon={icon} className={'align-text-top'} />
    <a className='pl-2' href={href}>
      {contact}
    </a>
  </div>
);

export const ContactUsModal = (props: ContactUsModalProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);
  const { show } = props;
  const userType = props.isDirectCustomer ? 'directCustomer' : 'tpi';
  const content = contentByUserType[userType];
  const paymentLink = 'https://drax.mysecurepay.co.uk/';

  const handlePaymentClick = () => {
    TagManager.pushData({
      event: 'External payment (Accounts & Sites)',
      customerAccountReference: userDetail.essCustomerId
    });
  };

  return (
    <>
      <Modal animation={false} className={'custom-modal'} show={show} backdrop='static' centered>
        <ContactUsWrapper>
          <Modal.Header className='pt-0 pb-0 pr-0'>
            <Modal.Title>
              <>{content.titleTop}</>
            </Modal.Title>
            <ModalClose onClick={() => props.onHide()} />
          </Modal.Header>
          <Modal.Body>
            <p>{content.headerTop}</p>

            <div className='pb-2'>
              <ContactInfo icon='envelope' contact={props.contactEmail} href={`mailto:${props.contactEmail}`} />
              <ContactInfo icon='headset' contact={props.contactNumber} href={`tel:${props.contactNumber}`} />
            </div>

            {content.titleBottom && (
              <p className='py-3 mb-0' style={{ fontWeight: 'bold' }}>
                {' '}
                {content.titleBottom}{' '}
              </p>
            )}

            {props.isDirectCustomer && (
              <ButtonPrimary className='paymentBtn' href={paymentLink} onClick={handlePaymentClick} target='_blank'>
                Make a payment
              </ButtonPrimary>
            )}

            {content.headerBottom && <p className='pt-2'>{content.headerBottom}</p>}

            <div className='pt-3' style={{ fontStyle: 'italic' }}>
              {' '}
              <p>{content.footer}</p>{' '}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ButtonPrimary onClick={() => props.onHide()} className={'m-0'} title='Ok' route='#' />
          </Modal.Footer>
        </ContactUsWrapper>
      </Modal>
    </>
  );
};

ContactUsModal.defaultProps = defaultProps;
